import React from 'react'
import { useNavigate } from 'react-router-dom'
import { makeStyles } from 'tss-react/mui'
import { useTheme } from '@mui/system'
import { Button } from '@mui/material'

import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { MultipleCars } from '@e3dc-react/icons'
import { Banner } from 'src/Components/banner'
import { BannerCloseTypes, BannerKey } from 'src/Libs/banners'
import { useTypedSelector } from 'src/State/RootReducer'
import viBannerBg from '../../assets/banner-background.png'

const useStyles = makeStyles()(theme => ({
  containerStyle: {
    backgroundImage: `url(${viBannerBg})`,
    backgroundColor: '#19290C',
    backgroundRepeat: 'no-repeat',

    [theme.breakpoints.up('xl')]: {
      /* For xl screens */
      backgroundPosition: '740px -47px',
      backgroundSize: '22.861% 240.036%',
    },
    [theme.breakpoints.between('lg', 'xl')]: {
      /* For lg screens */
      backgroundPosition: '479px -45px',
      backgroundSize: '31% 237.344%',
    },
    [theme.breakpoints.between('md', 'lg')]: {
      /* For md screens */
      backgroundPosition: '316px -51px',
      backgroundSize: '41.634% 250.453%',
    },
    [theme.breakpoints.between('sm', 'md')]: {
      /* For sm screens */
      backgroundPosition: '88px -49px',
      backgroundSize: '71.567% 173.947%',
    },
    [theme.breakpoints.down('sm')]: {
      /* For xs screens (mobile) */
      backgroundPosition: '0.414px -0.405px',
      backgroundSize: '152.381% 100%',
    },
  },
  textStyle: {
    color: theme.palette.common.white,
  },
  closeActionStyle: {
    color: theme.palette.common.white,
  },
}))

const NewVehicleManufacturesBanner: React.FC = () => {
  const { t } = useCustomTranslation()
  const { classes } = useStyles()
  const theme = useTheme()
  const navigate = useNavigate()
  const activeInstallation = useTypedSelector(state => state.storage.installation)

  const handleClick = (): void => {
    navigate(`/vehicle-integration/${activeInstallation?.id}/vehicle-integration`)
  }

  return (
    <Banner
      icon={<MultipleCars sx={{ color: theme.palette.primary.main, width: 70, height: 30 }} />}
      i18nKey="emobility.vehicle-integration.banners.new-manufacturers"
      bannerKey={BannerKey.NewVehicleManufacturersBanner}
      closeType={BannerCloseTypes.permanentOrTemporary}
      containerStyle={classes.containerStyle}
      textStyle={classes.textStyle}
      closeActionStyle={classes.closeActionStyle}
      button={
        <Button variant="contained" onClick={handleClick}>
          {t('emobility.vehicle-integration.connect-vehicle')}
        </Button>
      }
    />
  )
}

export default NewVehicleManufacturesBanner
